'use strict';

var React = require('react');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const GridWrapper = React.forwardRef(({ children, rowGap = 'm', columnGap = 'm', alignItems, justifyContent, ...props }, ref) => (React__default.default.createElement("div", { ...props, ref: ref },
    React__default.default.createElement(styles.StyledWrapper, { rowGap: rowGap, columnGap: columnGap, alignItems: alignItems, justifyContent: justifyContent }, children))));
GridWrapper.displayName = 'Grid.Wrapper';

exports.GridWrapper = GridWrapper;
//# sourceMappingURL=Wrapper.js.map
